module.exports = __webpack_public_path__ + "static/media/2XL.1799a935.jpg";